// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__r_tHJ","snowWebcamsWrapper":"styles_snowWebcamsWrapper__UNS4W","mostReportedSnowfallWrapper":"styles_mostReportedSnowfallWrapper__uYj7j"};